<button class="basemap-tile" (click)="changeBasemap()" (keydown.enter)="changeBasemap()">
  <img [ngSrc]="baseMap()" fill="true" [alt]="imgAltName()" priority="true" />
</button>
